import { render, staticRenderFns } from "./classifyProductList.vue?vue&type=template&id=2cbcf8fa"
import script from "./classifyProductList.vue?vue&type=script&lang=js"
export * from "./classifyProductList.vue?vue&type=script&lang=js"
import style0 from "./classifyProductList.vue?vue&type=style&index=0&id=2cbcf8fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports